<script lang="ts">
    import cn from "classnames";

    export let value: string | number;
    export let minLabel: string;
    export let maxLabel: string;
    export let midLabel = "";
    export let isCenteredRange = false;

    $: options = isCenteredRange ? [-1, -0.5, 0, 0.5, 1] : [1, 2, 3, 4, 5];
</script>

<div class="gw-range">
    <div class={`gw-range__${isCenteredRange ? "centeredRange" : "range"}`}>
        {#each options as item}
            <label
                class={cn(
                    "gw-range__item",
                    value === item && "gw-range__item-active"
                )}
            >
                <input type="radio" value={item} checked={value === item} />
                <span>
                    {isCenteredRange ? "" : item}
                </span>
            </label>
        {/each}
    </div>
    <div class="gw-range__scales">
        <span class="gw-range__scale">
            {minLabel}
        </span>
        {#if isCenteredRange}
            <span class="gw-range__scale">
                {midLabel}
            </span>
        {/if}
        <span class="gw-range__scale">
            {maxLabel}
        </span>
    </div>
</div>

<style lang="postcss">
    .gw-range {
        width: fit-content;
        display: flex;
        flex-direction: column;

        &__item {
            position: relative;
            font-size: var(--gw-rv-btn-text-sm, 12px);
            min-width: 47px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            padding: 0.5em;
            border-radius: 0.5em;
            border: 1px solid #d0d5dd;
            background: #fff;
            color: #1a1b1d;
            cursor: pointer;

            input[type="radio"] {
                position: absolute;
                width: 1px;
                height: 1px;
                overflow: hidden;
                clip: rect(0 0 0 0);
            }

            @media all and (max-width: 400px) {
                min-width: 38px;
            }
        }

        &__item-active {
            background-color: #e4e7ec;
            border: 1px solid #d0d5dd;

            &::before {
                content: none;
                background-color: #1a1b1d;
            }
        }

        &__range {
            display: flex;
            align-items: center;

            & > label {
                width: 49.5px;
                border-radius: 0.5em;

                &:not(:first-child) {
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    border-left: 0;
                }

                &:not(:last-child) {
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                }

                @media all and (max-width: 400px) {
                    width: 40px;
                }
            }
        }

        &__centeredRange {
            display: flex;
            align-items: center;
            gap: 0.125em;

            & > label {
                border-radius: 0.5em;

                &:not(:first-child) {
                    border-top-left-radius: 0.25em;
                    border-bottom-left-radius: 0.25em;
                }

                &:not(:last-child) {
                    border-top-right-radius: 0.25em;
                    border-bottom-right-radius: 0.25em;
                }

                &:nth-child(3) {
                    &::before {
                        content: "";
                        background-color: #d0d5dd;
                    }
                }

                &:nth-child(3).gw-range__item-active {
                    &::before {
                        background-color: #1a1b1d;
                    }
                }

                &::before {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                }
            }

            & > .gw-range__item-active {
                &::before {
                    content: "";
                }
            }
        }

        &__wrapper {
            width: fit-content;
            display: flex;
            flex-direction: column;
        }

        &__scales {
            display: flex;
            justify-content: space-between;
        }
        &__scale {
            flex-basis: 33.3%;
            font-size: 0.875em;
            font-style: normal;
            line-height: 26px;

            &:first-of-type {
                text-align: left;
                font-weight: 400;
            }
            &:nth-of-type(2) {
                text-align: center;
                font-weight: 600;
            }
            &:last-of-type {
                text-align: right;
                font-weight: 400;
            }
        }
    }
</style>
